const Survey = () => {
  return null;
};

export default Survey;
